import { Component, EventEmitter, OnInit, Output } from "@angular/core";

@Component({
  selector: "lfwms-feedback",
  templateUrl: "./feedback.component.html",
  styleUrls: ["./feedback.component.css"],
})
export class FeedbackComponent implements OnInit {
  constructor() { }

  @Output() feedbackClosed: EventEmitter<void> = new EventEmitter<void>();
  public ngOnInit() {
    window["screenName"] = "feedback";
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/layout/home/feedback/feedback.component.ts